webpackJsonp([87],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 2140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的查理宝支付宝流水ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入查理宝支付宝流水名称', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入至少2个字符', 'string'), { min: 2 })]
};

/***/ }),

/***/ 2548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clb_alipay_flow_rules_js__ = __webpack_require__(2140);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      id: 0,
      formRules: __WEBPACK_IMPORTED_MODULE_2__clb_alipay_flow_rules_js__["a" /* formRules */],
      form: {
        name: ''
      }
    };
  },

  computed: {},
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getClbAlipayFlowDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.form, data);
      });
    },
    getForm: function getForm() {
      return filter.copyJson(this.form);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.id ? _this2.update(_this2.id) : _this2.create();
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create() {
      var _this3 = this;

      request.common('createClbAlipayFlowData', this.getForm()).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this3.$refs.form.resetFields();
        }, function () {
          _this3.$router.push({ path: '/clb-alipay-flow/table/' });
        });
      });
    },
    update: function update(id) {
      var _this4 = this;

      request.common('updateClbAlipayFlowData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
        _this4.$confirm(_this4.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this4.$router.push({ path: '/clb-alipay-flow/table/' });
        });
      });
    }
  }
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClbAlipayFlowForm_vue__ = __webpack_require__(2548);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c28f83d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClbAlipayFlowForm_vue__ = __webpack_require__(3318);
function injectStyle (ssrContext) {
  __webpack_require__(3312)
  __webpack_require__(3314)
  this["$style"] = __webpack_require__(3316)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c28f83d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClbAlipayFlowForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c28f83d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClbAlipayFlowForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3312:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3313);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6fc1d1a5", content, true, {});

/***/ }),

/***/ 3313:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ClbAlipayFlowForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3314:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3315);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("d9973e26", content, true, {});

/***/ }),

/***/ 3315:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ClbAlipayFlowForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3316:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3317);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("89e3bbca", content, true, {});

/***/ }),

/***/ 3317:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ClbAlipayFlowForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/clb-alipay-flow/table"}},[_vm._v("查理宝支付宝流水列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"查理宝支付宝流水名称","prop":"name"}},[_c('el-input',{attrs:{"disabled":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"查理宝支付宝流水名称","prop":"name"}},[_c('el-input',{attrs:{"disabled":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/clb-alipay-flow-form.8c2b68e69dadf99f83e6.js